import accountManagement from 'sagas/accountManagement';
import accountSagas from 'sagas/account';
import accountsSagas from 'sagas/accounts';
import analyticsSagas from 'sagas/analytics';
import billing from 'sagas/billing';
import checklistSagas from 'sagas/checklists';
import chromeExtension from 'sagas/chromeExtension';
import dashboardSagas from 'sagas/dashboard';
import estimationSagas from 'sagas/estimation';
import eventSagas from 'sagas/events';
import exportSagas from 'sagas/exports';
import entitlementsSagas from 'sagas/entitlements';
import firebaseAuthSagas from 'sagas/firebase/auth';
import firebaseIoSagas from 'sagas/firebase/io';
import firebaseSyncAccountSagas from 'sagas/firebase/syncAccount';
import identifier from 'sagas/identifier';
import lastSeen from 'sagas/transitory/lastSeen';
import metricsSagas from 'sagas/metrics';
import routingSagas from 'sagas/routing';
import satisfactionSagas from 'sagas/satisfaction';
import segmentsSagas from 'sagas/account/segments';
import timingSaga from 'sagas/timing';
import userEventsSagas from 'sagas/userEvents';
import userProfileSagas from 'sagas/userProfiles';
import userSagas from 'sagas/user';
import view from 'sagas/view';

/**
 * NOTE: These imports are intentionally NOT public APIs of the entities and
 *       only to be used here for registering the sagas.
 */

/* eslint-disable no-restricted-imports */
import npsSaga from 'entities/nps/saga';
import keySaga from 'entities/keys/saga';
import userSegmentsSaga from 'entities/user-segments/saga';
import userQualifiedContentSaga from 'entities/user-qualified-content/saga';
import profileAttributeLabelsSaga from 'entities/profile-attribute-labels/saga';
import conditionsEstimatesSaga from 'entities/conditions-estimates/saga';
import experiencesSaga from 'entities/experiences/saga';
/* eslint-enable no-restricted-imports */

export const SAGAS = [
  ...accountSagas,
  ...firebaseIoSagas,
  accountsSagas,
  accountManagement,
  analyticsSagas,
  billing,
  checklistSagas,
  chromeExtension,
  dashboardSagas,
  entitlementsSagas,
  estimationSagas,
  eventSagas,
  exportSagas,
  firebaseAuthSagas,
  firebaseSyncAccountSagas,
  identifier,
  lastSeen,
  metricsSagas,
  routingSagas,
  satisfactionSagas,
  segmentsSagas,
  timingSaga,
  userEventsSagas,
  userProfileSagas,
  userSagas,
  view,
  npsSaga,
  keySaga,
  userSegmentsSaga,
  profileAttributeLabelsSaga,
  userQualifiedContentSaga,
  conditionsEstimatesSaga,
  experiencesSaga,
];
